export default class Attendance {
    // 获取考勤人数
    static getAttendanceNumber (sender, data, axiosOption, httpOption) {
      return sender.doUrl('/admin/upms/oaEmployeeDailyAttend/num', 'post', data, axiosOption, httpOption);
    }
    // 日常考勤列表
    static getDayAttendanceList (sender, data, axiosOption, httpOption) {
      return sender.doUrl('/admin/upms/oaEmployeeDailyAttend/employeeAttendList', 'post', data, axiosOption, httpOption);
    }
    // 工作流字典接口
    static gitDict(sender, data, axiosOption, httpOption) {
        return sender.doUrl('/admin/online/onlineOperation/listDict', 'post', data, axiosOption, httpOption);
    }
    // 月度考勤 
    static getMonthAttendanceList (sender, data, axiosOption, httpOption) {
        return sender.doUrl('/admin/upms/oaEmployeeDailyAttend/monthStatistics', 'post', data, axiosOption, httpOption);
    }
    // 获取月度考勤人数
    static getMonthAttendanceNumber (sender, data, axiosOption, httpOption) {
        return sender.doUrl('/admin/upms/oaEmployeeDailyAttend/monthNum', 'post', data, axiosOption, httpOption);
    }
  // 考勤异常 
  static getAbnormalAttend (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaEmployeeDailyAttend/abnormalAttend', 'post', data, axiosOption, httpOption);
  }
  // 考勤异常 有状态
  static getAttendanceState (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaEmployeeDailyAttend/listAbnormal', 'post', data, axiosOption, httpOption);
  }
  // 请假统计人数 
  static getLeaveNum(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaPayApproval/num', 'post', data, axiosOption, httpOption);
  }
  // 请假统计列表 
  static getLeaveList(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaPayApproval/qjsqList', 'post', data, axiosOption, httpOption);
  }
  // 忘记打卡 
  static getForgotClockIn(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaEmployeeDailyAttend/forgotClockIn', 'post', data, axiosOption, httpOption);
  }
  // 加班接口 
  static getAddWork(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaEmployeeDailyAttend/addWork', 'post', data, axiosOption, httpOption);
  }
  // 员工节假日 查询
  static getList(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/calendarConfig/list', 'post', data, axiosOption, httpOption);
  }
  // 员工节假日 新增
  static createDay(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/calendarConfig/add', 'post', data, axiosOption, httpOption);
  }// 员工节假日 新增
  static deleteDay(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/calendarConfig/delete', 'post', data, axiosOption, httpOption);
  }
  // 销假 
  static getQjList(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaPayApproval/getOaFlowQjsq', 'post', data, axiosOption, httpOption);
  }
  // 首页饼图
  static getIndexPie(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaEmployeeDailyAttend/pie', 'post', data, axiosOption, httpOption);
  }
}